import { useContext } from 'react';
import { ConfigContext } from '../PassportProvider';

const defaultConfig = {};
export function useConfig(code) {
  const config = useContext(ConfigContext) || defaultConfig;
  return config[code] || defaultConfig;
}
